export function usePrintDataParam(location: any) {
  const printData = new URLSearchParams(location.search).get('print') || ''
  if (printData && printData === '1') {
    return true
  }
  return false
}
